(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'underscore'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'), require('underscore'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function ($, _) {
  'use strict';

    /**
     * Configures backbone validation for the portal application.
     * Sets up the validation formatters to use i18n, and adds
     * custom validators.
     *
     * @method configureValidation
     */

  return {
    addCustomValidation: function(TorsoValidation) {
      // Add additional custom validators that can be used across the application.
      _.extend(TorsoValidation.validators, {
        /**
         * This validation will pass the main validation logic to this.required.
         * @return {Object} If a validation error has occurred, it will return: {
         *   key: 'required.failed',
         *   params: <field name>
         * }
         * otherwise it will return ''
         * @method requiredField
         * @for Torso.Validation.validators
         */
        requiredField: function(value, attr, params, model, computed) {
          var shouldValidateNotSet = !params.shouldValidate,
              shouldValidate = shouldValidateNotSet || _.result(model, params.shouldValidate),
              requiredError = this.required(value, attr, true, model, computed);
          if (shouldValidate && requiredError) {
            return {
              key: 'required.failed',
              params: attr
            };
          } else {
            return '';
          }
        }
      });
    },


    addFormViewFormatters: function(TorsoFormView) {
      // Add formatting to form view
      _.extend(TorsoFormView.prototype, {
        /**
         * Formats an i18n key into text
         * Three ways to invoke format:
         * view.format('my.message.key', param1, param2, param3);
         * view.format('my.message.key', [param1, param2, param3]);
         * view.format({key: 'my.message.key', params: [param1, param2, param3]});
         * where params are optional in both cases
         * @param [key || {key: String, params: Array}] {String or Array} the i18n key
         * @param [params] {Array of objects}
         * @method format
         * @for Torso.Views.Form
         */
        format: function() {
          var params, args,
            key = arguments[0];
          if (arguments.length === 2 && _.isArray(arguments[1])) {
            params = arguments[1];
          } else {
            params = Array.prototype.slice.call(arguments, 1);
          }
          if (_.isObject(key)) {
            params = key.params;
            key = key.key;
          }
          args = params.slice();
          if ($.i18n.map[key]) {
            args.unshift(key);
            return $.i18n.prop.apply($.i18n.prop, args);
          } else {
            return key;
          }
        },

        /**
         * Attempts to map a result to a format key with the right parameters. The 'result' argument is typically what is returned from
         * a form model's preValidation call. The 'result' argument can be a string or an object with 'key' and 'params' fields.
         * You can give a map from possible results (more specifically the result keys) to i18n keys. That map can have values that
         * are just i18n keys or objects with 'key' and 'params' fields. If the matching map value has a 'params' field, it will use these
         * instead of the 'params' on the 'result'. As a third parameter, you can pass in override parameters to be used to override
         * parameters set by result. Note, that if the map contains parameters, these will take precedence over the override parameters
         *
         * Example 1: _thenFormatFeedback('my.key')
         *              ===> this.format('my.key')
         *
         * Example 2: _thenFormatFeedback('my.key', {}, [param1, param2])
         *              ===> this.format('my.key', [param1, param2])
         *
         * Example 3: _thenFormatFeedback('my.key', {'my.key': 'the.i18n.key'})
         *              ===> this.format('the.i18n.key')
         *
         * Example 4: _thenFormatFeedback('my.key', {'my.key': 'the.i18n.key'}, [param1, param2])
         *              ===> this.format('the.i18n.key', [param1, param2])
         *
         * Example 5: _thenFormatFeedback('my.key', {'my.key': {key: 'the.i18n.key', params: [mapParam1, mapParam2]}})
         *              ===> this.format('the.i18n.key', [mapParam1, mapParam2])
         * In example 5, if you passed any parameters as the third argument, they will not be used.
         *
         * Example 6: _thenFormatFeedback({key: 'my.key', params: [param1, param2]})
         *              ===> this.format('my.key', [param1, param2])
         *
         * Example 7: _thenFormatFeedback({key: 'my.key', params: [param1, param2]}, {}, [altParam1, altParam2])
         *              ===> this.format('my.key', [altParam1, altParam2])
         *
         * Example 8: _thenFormatFeedback({key: 'my.key', params: [param1, param2]}, {'my.key': 'the.i18n.key'})
         *              ===> this.format('the.i18n.key', [param1, param2])
         *
         * Example 9: _thenFormatFeedback({key: 'my.key', params: [param1, param2]}, {'my.key': 'the.i18n.key'}, [altParam1, altParam2])
         *              ===> this.format('the.i18n.key', [altParam1, altParam2])
         *
         * Example 10: _thenFormatFeedback({key: 'my.key', params: [param1, param2]}, {'my.key': {key: 'the.i18n.key', params: [mapParam1, mapParam2]}})
         *              ===> this.format('the.i18n.key', [mapParam1, mapParam2])
         * In example 10, if you passed any parameters as the third argument, they will not be used
         * @param result {String or Object with 'key' and 'params'}
         * @param matchMap {Object} keys are the strings you will be matching against the result,
         *                           values are the format key or an object with key and param fields.
         * @param overrideParams {Array} i18n parameters that will be used to override the result's parameters.
         * @private
         * @method _thenFormatFeedback
         * @for Torso.Views.Form
         */
        _thenFormatFeedback: function(result, matchMap, overrideResultParams) {
          var formatKeyToUse, params,
            formattedText = '';
          if (_.isString(result)) {
            if (_.isEmpty(matchMap)) {
              // If the result is a string and we don't have to match with anything, then assume
              // that the string is an i18n key.
              return {
                text: this.format(result, overrideResultParams)
              };
            } else {
              // If it's a string but we do have to match, then put the string in a form that we can do matching
              result = {
                key: result
              };
            }
          }
          params = overrideResultParams ? overrideResultParams : result.params;
          if (_.isEmpty(matchMap)) {
            return {
              text: this.format(result.key, params)
            };
          } else {
            // Find the format key that corresponds to the result key
            formatKeyToUse = _.find(matchMap, function(formatKey, matchKey) {
              return result.key === matchKey;
            });
            if (formatKeyToUse) {
              // If we found a format key, then format it with the provided needed params
              if (_.isObject(formatKeyToUse)) {
                // The format key can pass its own params, so we'll use those instead of the passed in default params
                params = formatKeyToUse.params;
                formatKeyToUse = formatKeyToUse.key;
              }
              formattedText = this.format(formatKeyToUse, params);
            }
            return {
              text: formattedText
            };
          }
        }
      });
    }
  };
}));
